import UserModel from "@/project/model/UserModel";

export default class CompanyModel {

    id = 0;
    code = '';
    category = 0;
    name = '';
    address = '';
    contactName = '';
    phone = '';
    mobile = '';
    email = '';
    remark = '';
    createUid = 0;
    updateUid = 0;
    createTime = '';
    categoryName = '';
    createUserName = '';
    updateUserName = '';
    updateTime = '';

}